import { render, staticRenderFns } from "./reviewGroup.vue?vue&type=template&id=235de342&scoped=true&"
import script from "./reviewGroup.vue?vue&type=script&lang=js&"
export * from "./reviewGroup.vue?vue&type=script&lang=js&"
import style0 from "./reviewGroup.vue?vue&type=style&index=0&id=235de342&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235de342",
  null
  
)

export default component.exports